import { useRef, useState } from 'react';
import { Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import QrCodeIcon from '@mui/icons-material/QrCode2';
import DownloadIcon from '@mui/icons-material/Download';
import { QRCodeCanvas } from 'qrcode.react';

import { companySlug } from '../../common/signupLink.js';
import './SignupLinkShare.css';

// Large enough to print on a poster without the modules blurring.
const QR_SIZE_PX = 512;

// The link's URL with a copy button, and a QR code of it that can be downloaded as a PNG. The
// code is drawn in the browser, so the link never passes through an outside service. A list row
// can leave the URL out, hide the QR code for a link that no longer works, and add its own
// buttons beside the others.
const SignupLinkShare = ({ url, fileName, showUrl = true, allowQr = true, extraActions = null }) => {
    const [copied, setCopied] = useState(false);
    const [showQr, setShowQr] = useState(false);
    const qrWrapperRef = useRef(null);

    const copy = async () => {
        await navigator.clipboard.writeText(url);
        setCopied(true);
    };

    const download = () => {
        const canvas = qrWrapperRef.current?.querySelector('canvas');
        if (!canvas) return;
        const anchor = document.createElement('a');
        anchor.href = canvas.toDataURL('image/png');
        anchor.download = `${companySlug(fileName) || 'tilmeldingslink'}-qr.png`;
        anchor.click();
    };

    return (
        <div className="signup-share">
            {showUrl && <div className="signup-share-url">{url}</div>}
            <div className="signup-share-actions">
                <Button size="small" startIcon={<ContentCopyIcon />} onClick={copy}>
                    {copied ? 'Kopieret' : 'Kopiér link'}
                </Button>
                {allowQr && (
                    <Button size="small" startIcon={<QrCodeIcon />} onClick={() => setShowQr((shown) => !shown)}>
                        {showQr ? 'Skjul QR-kode' : 'Vis QR-kode'}
                    </Button>
                )}
                {extraActions}
            </div>
            {allowQr && showQr && (
                <div className="signup-share-qr" ref={qrWrapperRef}>
                    <QRCodeCanvas value={url} size={QR_SIZE_PX} marginSize={4} level="M" />
                    <Button size="small" startIcon={<DownloadIcon />} onClick={download}>
                        Download PNG
                    </Button>
                </div>
            )}
        </div>
    );
};

export default SignupLinkShare;
